import { PermissionHas } from "../../../_ovlclient/src/global/globalapi"
import {
  OvlAddComponent,
  OvlAddDialog,
} from "../../../_ovlclient/src/global/globals"
import { DialogSYSUserAdministrationCompany } from "./features/company/company"
import { CompSYSUserAdministrationSettings } from "./parts/settings"
import { DialogSYSUserAdministrationPermission } from "./features/permission/dialogpermission"
import { CompSYSUserAdministrationPermission } from "./features/permission/permission"
import { DialogSYSUserAdministrationRole } from "./features/role/role"
import { DialogUserAdministrationUser } from "./features/user/user"
import { DialogSYSUserAdministrationUserRole } from "./features/userrole/userrole"
import { DialogSYSUserAdministrationUserRoleTransfer } from "./features/userroletransfer/userroletransfer"
export const SYSUserAdministration_Init = () => {
  if (PermissionHas("SYSUA") || PermissionHas("SYSRA")) {
    OvlAddDialog(DialogUserAdministrationUser, "SYSUserAdministration_User")
    OvlAddDialog(
      DialogSYSUserAdministrationUserRoleTransfer,
      "SYSUserAdministration_UserRoleTransfer"
    )
    OvlAddDialog(
      DialogSYSUserAdministrationCompany,
      "SYSUserAdministration_Company"
    )
    OvlAddDialog(DialogSYSUserAdministrationRole, "SYSUserAdministration_Role")
    OvlAddDialog(
      DialogSYSUserAdministrationUserRole,
      "SYSUserAdministration_UserRole"
    )
    OvlAddDialog(
      DialogSYSUserAdministrationPermission,
      "SYSUserAdministration_Permission"
    )
    OvlAddComponent(
      "comp-sysuseradministrationpermission",
      CompSYSUserAdministrationPermission
    )
    OvlAddComponent(
      "comp-sysuseradministrationsettings",
      CompSYSUserAdministrationSettings
    )
  }
}
